// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__WgvpF","title":"styles_title__kgO5t","grid":"styles_grid__xDUq0","card":"styles_card__KVARD","text":"styles_text__WFrH4"};